module.exports = "/lucky-balls/img/color_betting/green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/green.png
// module id = 979
// module chunks = 0